// extracted by mini-css-extract-plugin
export default {"mainWrapper":"generic-information_mainWrapper__1f+tH","header":"generic-information_header__20FsU"};